<template>
  <vue-modal
    :name="name"
    :width="width"
    :height="height"
    reset
    :click-to-close="dismissable"
    transition="scale"
    class="dash-modal"
    @opened="$emit('opened')"
    @closed="$emit('closed')"
  >
    <div>
      <div class="modal">
        <div class="top-bar">
          <h1 v-if="header" class="header">
            {{ header }}
          </h1>
          <button
            class="close-button"
            @click="$modal.hide(name)"
          >
            <img class="icon" src="~@/assets/icon-close.svg">
          </button>
        </div>
        <div class="contents">
          <slot name="contents" />
        </div>
        <div class="actions">
          <slot name="actions">
            <div>
              <button
                :id="`modal_${name}_close`"
                class="button"
                @click="$modal.hide(name)"
              >
                Ok
              </button>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </vue-modal>
</template>

<script>
export default {
  name: 'DashModal',
  props: {
    header: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    width: {
      type: [String, Number],
      default: 542,
    },
    height: {
      type: [String, Number],
      default: 270,
    },
    dismissable: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/variables";
@import "~@/assets/scss/buttons";

.button {
  @include button($orange, $orange, $white);
  height: 50px;
  width: 200px;
}

.modal {
  padding: 24px;
  height: 270px;
  width: 542px;
  border-radius: $radius;
  background-color: $charcoal-nero;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  box-sizing: border-box;

  .top-bar {
    display: flex;
    margin-bottom: 24px;
    flex-wrap: nowrap;
    height: 35px;
  }
  .header {
    font-size: $size-3;
    font-weight: $weight-black;
    flex-grow: 1;
    color: $white;
    line-height: 30px;
    margin: 0;
  }
  .close-button {
    min-width: 13px;
    width: 13px;
    height: 13px;
    border: none;
    background: none;
    padding-left: 0;
    padding-right: 0;

    & .icon {
      margin: 0;
      width: 100%;
    }
  }
  .contents {
    flex-grow: 1;
    font-size: $size-4;
    font-weight: $weight-normal;
    color: $white;
  }
}
.actions {
  display: flex;
  justify-content: flex-end;
}
</style>
<style lang="scss">
  /* Please note this stylesheet is not scoped so that overriding
   * of the styles for vue-js-modal component */
.dash-modal {
  .v--modal {
    border-radius: 2px;
    background: none;
    box-shadow: inset 0 -1px 0 0 #333333, 0 5px 30px 0 rgba(0,0,0,0.24);
  }
  &.v--modal-overlay {
    background: rgba(0,0,0,.4);
  }
}
.scale-enter-active,
.scale-leave-active {
  transition: all 0.2s;
}
.scale-enter,
.scale-leave-active {
  opacity: 0;
  transform: scale(0.3) translateY(24px);
}
</style>
